/** Interface strings of the first-run intro (wording follows the bot onboarding). */
export const introMessages = {
  "intro.title": { ru: "Это Mioscape", en: "This is Mioscape" },
  "intro.body": {
    ru: "Я помогаю вести то, что обычно живёт в голове, в заметках или в таблице: расходы, тренировки, показания счётчиков, списки дел. Вы описываете словами, что хотите вести, а я собираю готовый раздел — с формой записи, списком и сводкой. Напоминания работают сразу.",
    en: "I help you keep track of things that usually live in your head, in notes, or in a spreadsheet: expenses, workouts, meter readings, to-dos. You describe what you want to track in your own words and I build a ready-made section — an entry form, a list and a summary. Reminders work out of the box.",
  },
  "intro.examples": { ru: "Три примера", en: "Three examples" },
  "intro.expenses.name": { ru: "Расходы", en: "Expenses" },
  "intro.expenses.prompt": {
    ru: "«Хочу вести траты по категориям» — форма записи, список за месяц и сводка по категориям.",
    en: '"Track spending by category" — an entry form, a monthly list and a per-category summary.',
  },
  "intro.workouts.name": { ru: "Тренировки", en: "Workouts" },
  "intro.workouts.prompt": {
    ru: "«Записывать упражнения, подходы и вес» — журнал занятий и история по каждому упражнению.",
    en: '"Log exercises, sets and weight" — a training journal and per-exercise history.',
  },
  "intro.meters.name": { ru: "Счётчики", en: "Meters" },
  "intro.meters.prompt": {
    ru: "«Показания воды и электричества раз в месяц» — форма, которая помнит прошлое значение и сама считает расход.",
    en: '"Water and electricity once a month" — a form that remembers the previous reading and works out the difference.',
  },
  "intro.cta": {
    ru: "Описать, что вести",
    en: "Describe what to track",
  },
  "intro.skip": { ru: "Пропустить", en: "Skip" },
} as const;
